module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_3016.fc808053.png";